module.exports = __webpack_public_path__ + "static/media/Promos_3x2.84314d78.png";